import { createSlice } from '@reduxjs/toolkit';

export interface UserdataModel {
  isAuth: boolean;
  username: string;
  roles: string[];
  actions: string[];
}

const initialState: UserdataModel = {
  isAuth: false,
  username: '',
  roles: [],
  actions: [],
};

export const userdataSlice = createSlice({
  name: 'userdata',
  initialState,
  reducers: {
    pushUserdata: (state, action: { payload: UserdataModel }) => ({
      ...state,
      ...action.payload,
    }),
    resetUserdata: () => initialState,
  },
});

export const { pushUserdata, resetUserdata } = userdataSlice.actions;

export default userdataSlice.reducer;
